const frontData = [
  {
    id: 1,
    name: "What is HTML ?",
    img: "https://icons.iconarchive.com/icons/cornmanthe3rd/plex/256/Other-html-5-icon.png",
    meaning:
      "- HTML stands for Hyper Text Markup Language - It is the standard markup language for creating Web pages designed to be displayed in a web browser. - Web browsers receive HTML documents and render the documents into multimedia web pages. - It describes the structure of a Web page - HTML elements are the building blocks of HTML pages. - HTML elements tell the browser how to display the content - With HTML constructs, images and other objects such as interactive forms may be embedded into the rendered page. - Browsers do not display the HTML tags, but use them to interpret the content of the page."
  },
  {
    id: 2,
    name: "What is CSS ?",
    img: "https://www.freepnglogos.com/uploads/html5-logo-png/html5-logo-opencode-css-8.png",
    meaning:
      "- CSS stands for Cascading Style Sheets - CSS describes how HTML elements are to be displayed on screen, paper, or in other media - CSS saves a lot of work. It can control the layout of multiple web pages all at once - External stylesheets are stored in CSS files."
  },
  {
    id: 3,
    name: "What is JavaScript ?",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSKXQ6aMdHX5vRYnRSyo9OdagU1D2Fhx_t4nsARH1geBtpa7CI&s",
    meaning:
      "- JavaScript® (often shortened to JS) is a lightweight, interpreted, object-oriented language with first-class functions, and is best known as the scripting language for Web pages, but it's used in many non-browser environments as well. It is a scripting language that is dynamic, and supports object-oriented, functional programming styles. - JavaScript runs on the client side of the web, which can be used to design / program how the web pages behave on the occurrence of an event. JavaScript is an easy to learn and also powerful scripting language, widely used for controlling web page behavior. - Contrary to popular misconception, JavaScript is not Interpreted Java."
  },
  {
    id: 4,
    name: "What is Bootstrap ?",
    img: "https://upload.wikimedia.org/wikipedia/commons/b/b2/Bootstrap_logo.svg",
    meaning:
      "- Bootstrap is a free front-end framework for faster and easier web development. Bootstrap includes HTML and CSS based design templates for typography, forms, buttons, tables, navigation, modals, image carousels and many other, as well as optional JavaScript plugins. - Bootstrap also gives you the ability to easily create responsive designs."
  },
  {
    id: 5,
    name: "What is React ?",
    img: "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg",
    meaning:
      "React (also known as React.js or ReactJS) is an open-source, front end, JavaScript library for building user interfaces or UI components. It is maintained by Facebook and a community of individual developers and companies. React can be used as a base in the development of single-page or mobile applications. However, React is only concerned with rendering data to the DOM."
  },
  {
    id: 6,
    name: "What is Redux ?",
    img: "https://upload.wikimedia.org/wikipedia/commons/4/49/Redux.png",
    meaning:
      "Redux is an open-source JavaScript library for managing application state. It is most commonly used with libraries such as React or Angular for building user interfaces. Similar to (and inspired by) Facebook's Flux architecture."
  },
  {
    id: 7,
    name: "Best Frontend Course Roadmap for beginners(ACM Suggestion)",
    meaning:
      "(For those who wish to go through the basics, else just skip to the projects) (Documentation is the official way to learn the technology so no need to go through it if you have already followed the steps before it! It is great for when you get stuck somewhere.)",
    list1: "HTML and CSS Crash Course Playlist ",
    href1:
      "https://www.youtube.com/playlist?list=PL4cUxeGkcC9ivBf_eKCPIAYXWzLlPAm6G",
    list2: "Complete blooger website using HTML & CSS ",
    list3: "JS Crash Course Traversy Media ",
    list4:
      "For learning particular things in JavaScript, can refer to techsith youtube channel ",
    list5: "Bootstrap 5 crash course ",
    list6: "Bootstrap 5 landing page project ",
    list7: "Bootstrap 5 official website ",
    list8: "Complete React with Redux ",
    list9: "React Context & Hooks ",
    list10: "NetNinja React Project "
  },
  {
    id: 8,
    name: "Sites for Reference",
    meaning: " ",
    list1: "w3Schools HTML Tutorial ",
    href1: "https://www.w3schools.com/html/html_intro.asp",
    list2: "Documentation "
  }
];

export default frontData;
